import React from 'react';

function PageLoader() {
  return <div className="page-loader">Laden...</div>;
}

export default PageLoader;
